import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CutsceneTemplat from '../Components/Layout/CutsceneTemplate';

import Commander from '../Assets/Imgs/Commander.png';
import Mike from '../Assets/Imgs/Mike.png';
import Btn from '../Components/Common/Btn';

import Pause from '../Assets/Icons/Pause.svg'
import PauseMenu from '../Components/Layout/PauseMenu';
import BGMusic from '../Components/Common/BackgroundMusic';
import BGSong from '../Assets/Sounds/seventeensplitcfg.wav';

const IntroCutscene = (musicVolume, setMusicVolume) => {

    const [currentLine, setCurrentLine] = useState(0)
    const [isPaused, setIsPaused] = useState(false);

    const navigate = useNavigate();

    const dialogue = [
        {
            img: Commander, text: 'Private Mike, you’re about 800m away from the station, decelerate and prepare to infiltrate.', DName: 'Commander'
        },

        {
            img: Mike, text: 'Affirmative commander, I have a visual on the station.', DName: 'Private Mike'
        },

        {
            img: Commander, text: `This thing hasn’t been visited in decades so unfortunately we don’t have any blueprints available. move carefully`, DName: 'Commander'
        }
    ]

    const handleNextDialogue = () => {
        if (currentLine < dialogue.length - 1) {
            setCurrentLine(prevStep => prevStep + 1);
        } else {
            navigate('/L1');
        }
    };

    const currentDialogue = dialogue[currentLine];
    console.log(dialogue[0])

    return ( 
        <main className='IntroCutsceneMain'>
            <BGMusic 
                src={BGSong} 
                volume={musicVolume / 100} 
                isPlaying={true} 
            />

            <Btn BtnIcon={Pause} BtnStyle="PauseBtn" onClick={() => setIsPaused(true)}/>
            
            <CutsceneTemplat TemplateClass='IntroTemplate' DialogueImg={currentDialogue.img} DialogueName={currentDialogue.DName} DialogueP={currentDialogue.text} NextBtnChange={handleNextDialogue}/>

            {isPaused && <PauseMenu ResumeClick={()=>setIsPaused(false)}/>}
        </main>
     );
}
 
export default IntroCutscene;